import { IConfig } from '@/src/app/core/interfaces';
import { AppConfigService } from '@/src/app/core/services';
import { Component, EventEmitter, Input, Output } from '@angular/core';

/**
 * MainMenuComponent
 *
 * @export
 * @class MainMenuComponent
 * @typedef {MainMenuComponent}
 */
@Component({
  selector: 'aup-main-menu',
  templateUrl: './main-menu.component.html',
  styleUrls: ['./main-menu.component.scss'],
  standalone: false,
})
export class MainMenuComponent {
  @Input() isMenuExpanded = false;
  @Input() isMobile = false;
  /**
   * Emit event on menu position click
   *
   * @type {EventEmitter<void>}
   */
  @Output() closeDrawerIfMobile: EventEmitter<void> = new EventEmitter();

  appConfig?: IConfig;
  public shouldShowSettingsMenu = false;

  constructor(private appConfigService: AppConfigService) {
    this.appConfig = this.appConfigService.getConfig();
    this.shouldShowSettingsMenu = this.appConfigService.isSettingsModuleEnabled();
  }

  /**
   * Handle menu position click
   */
  onCloseDrawerIfMobile() {
    this.closeDrawerIfMobile.emit();
  }
}
